import { Component, OnInit } from '@angular/core';
import { BaseKnowledgeCatalogService } from './services/base-knowledge-catalog.service';
import { ArtifactStatus, IKBCatalog, IKBCatalogCategory } from './interfaces/IBase-knowledge-catalog';
import { I18nService } from 'i18n/i18n.service';

@Component({
  selector: 'biz-base-knowledge-catalog',
  templateUrl: './base-knowledge-catalog.component.html',
  styleUrls: ['./base-knowledge-catalog.component.scss']
})
export class BaseKnowledgeCatalogComponent implements OnInit {

  public allCategory: IKBCatalogCategory = { DisplayName: 'All', Description: 'All', Id: 'All', Expanded: false, KBCatalogs: [] };
  public categoryList: IKBCatalogCategory[] = [];
  public filteredCategoryList: IKBCatalogCategory[] = [];
  public selectedCategory: IKBCatalogCategory;
  public Processing = ArtifactStatus.Processing;
  public Available = ArtifactStatus.Available;
  public Failed = ArtifactStatus.Failed;
  public ToProcess = ArtifactStatus.ToProcess;
  public Unknown = ArtifactStatus.Unknown;
  public inputSearch = '';

  constructor(
    private _baseKnowledgeCatalogService: BaseKnowledgeCatalogService,
    private _i18nService: I18nService) { }

  ngOnInit(): void {
    this._baseKnowledgeCatalogService.getBaseKnowledgeCatalog().subscribe((res) => {
      if (res.length > 0) {
        this.categoryList = res;
        this.setArtifactStatusLocalized();
        this.selectedCategory = this.allCategory;
        this.filteredCategoryList = this.categoryList;
      }
    });
  }

  setArtifactStatusLocalized(): void {
    this.categoryList.forEach(category => {
      category.KBCatalogs.forEach(catalog => {
        catalog.KBArtifacts.forEach(artifact => {
          artifact.ArtifactStatus = artifact.ArtifactStatus.toUpperCase();
          artifact.ArtifactStatusLocalized = this._i18nService.instant('BASEKNOWLEDGECATALOG.ARTIFACT_STATUS.' + artifact.ArtifactStatus.toLocaleUpperCase());
        });
      });
    });
  }

  collapsedList(): void {
    this.filteredCategoryList.forEach((category, categoryIndex) => {
      if (categoryIndex === 0) {
        category.Expanded = true;
        category.KBCatalogs.forEach((catalog, catalogIndex) => {
          catalog.Expanded = catalogIndex === 0;
        });
      } else {
        category.Expanded = false;
        category.KBCatalogs.forEach(catalog => {
          catalog.Expanded = false;
        });
      }
    });
  }

  expandResults(searchResults: IKBCatalogCategory[]): IKBCatalogCategory[] {
    searchResults.forEach(category => {
      if (category.KBCatalogs.length > 0) {
        category.Expanded = true;
      }
      category.KBCatalogs.forEach(catalog => {
        if (catalog.KBArtifacts.length > 0) {
          catalog.Expanded = true;
        }
      });
    });
    return searchResults;
  }

  onCategoryChange(event: IKBCatalogCategory): void {
    if (event.Id === 'All') {
      this.filteredCategoryList = this.categoryList;
      this.collapsedList();
    } else {
      this.filteredCategoryList = this.categoryList.filter(category => category.Id === event.Id);
    }
  }

  onEnterSearch(): void {
    this.onSearch(this.inputSearch);
  }

  onSearch(searchString: string): void {
    this.inputSearch = searchString;
    const lowerCaseSearchString = searchString.toLowerCase();
    this.selectedCategory = this.allCategory;
  
    if (lowerCaseSearchString === '') {
      this.filteredCategoryList = this.categoryList;
      this.collapsedList();
      return;
    } else {
      let searchResultCategories = this.categoryList.filter(category => {
        const matchingCatalogs = category.KBCatalogs.filter(catalog => {
          const matchingArtifacts = catalog.KBArtifacts.filter(artifact =>
            artifact.DisplayName.toLowerCase().includes(lowerCaseSearchString)
          );
          catalog.Expanded = matchingArtifacts.length > 0 || catalog.DisplayName.toLowerCase().includes(lowerCaseSearchString);
          return catalog.Expanded;
        });
        category.Expanded = matchingCatalogs.length > 0 || category.DisplayName.toLowerCase().includes(lowerCaseSearchString);
        return category.Expanded;
      });
  
      this.filteredCategoryList = searchResultCategories;
    }
  }


  toggleCategory(category: IKBCatalogCategory): void {
    category.Expanded = !category.Expanded;
  }

  toggleCatalog(catalog: IKBCatalog): void {
    catalog.Expanded = !catalog.Expanded;
  }
}
